import { render, staticRenderFns } from "./OnboardingStepDots.vue?vue&type=template&id=81ff77ea&"
import script from "./OnboardingStepDots.vue?vue&type=script&lang=js&"
export * from "./OnboardingStepDots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports